import { useContext } from 'react'
import GeoContext from 'contexts/geoContext'
import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import useFeatureFlag from 'hooks/Experiments/useFeatureFlag'
import { offerHasTheresNoPlaceLikeHomeCampaignTag } from 'lib/offer/theresNoPlaceLikeHomeCampaignTag'

export function useShowNoPlaceLikeHomeLabel(campaignTags: Array<string> | undefined): boolean {
  const { currentRegionCode } = useContext(GeoContext)
  const isEnabled = useFeatureFlag(OptimizelyFeatureFlags.noPlaceLikeHomeCampaign)
  return currentRegionCode === 'AU' && isEnabled && offerHasTheresNoPlaceLikeHomeCampaignTag(campaignTags)
}
